// app/timeSheetMensile/timeSheetMensile.js

(function () {
    'use strict';
    var controllerId = 'timeSheetMensile';
    angular.module('app').controller(controllerId, ['$rootScope', 'datacontext', 'common', 'sectionMenu', '_', 'moment', 'bootstrap.dialog', '$uibModal', '$translate', 'amMoment', 'tmhDynamicLocale', timeSheetMensileFn]);

    function timeSheetMensileFn($rootScope, datacontext, common, sectionMenu, _, moment, bDialog, $uibModal, $translate, amMoment, tmhDynamicLocale) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 
        var detectIE = $rootScope.detectIE;

        var vm = this;
        vm.title = 'TimeSheetMensile';
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        vm.timeSheet = {};
        vm.list = {};
        vm.giorni = [];
        vm.gSett = [];
        vm.date = [];                                           //Questo contiene le date da inserire nella tabella ore
        vm.colSabati = [];
        vm.colDomeniche = [];
        vm.colFestivo = [];
        vm.colTitle = [];

        vm.bSelDipendente = false;
        if ($rootScope.isAuthorized('PERSONALE') || $rootScope.isAuthorized('CAPOSEZIONE'))
            vm.bSelDipendente = true;

        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();
        amMoment.changeLocale(vm.currentLanguage);
        tmhDynamicLocale.set(vm.currentLanguage);

        vm.righeC = [];
        vm.righeG = [];

        vm.dipendente = {};
        vm.dipendente.Profilo = [0, 0, 0, 0, 0, 0, 0];

        //Metodi su interfaccia
        vm.next = next;
        vm.prev = prev;
        vm.selezionaDipendente = selezionaDipendente;
        vm.annullaDipendente = annullaDipendente;
        vm.getTimeSheet = getTimeSheet;
        vm.printTimeSheet = printTimeSheet;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            vm.loading = true;
            var promises = [getDipendente(), getHolidays()];
            common.activateController(promises, controllerId).then(function () {
                datacontext.timeSheet_getDate().then(function (data) {
                    if (data) {
                        data = new Date(data);
                        vm.fAnno = data.getFullYear();
                        vm.fMese = data.getMonth() + 1;
                    }

                    getTimeSheet();
                });
            });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function getDipendente(id) {
            if ($rootScope.isAuthorized('USER') || !id)
                id = $rootScope.id ? $rootScope.id : 0;

            return datacontext.dipendente_get(id).then(function (data) {
                vm.dipendente = data;
                vm.dipendente.Profilo = [0, 0, 0, 0, 0, 0, 0];
                if (data.ProfiloOreId) {
                    datacontext.profiloOre_get(data.ProfiloOreId).then(function (profilo) {
                        if (profilo) {
                            vm.dipendente.ProfiloOreDescrizione = profilo.Descrizione;
                            vm.dipendente.Profilo[0] = profilo.Ore1;
                            vm.dipendente.Profilo[1] = profilo.Ore2;
                            vm.dipendente.Profilo[2] = profilo.Ore3;
                            vm.dipendente.Profilo[3] = profilo.Ore4;
                            vm.dipendente.Profilo[4] = profilo.Ore5;
                            vm.dipendente.Profilo[5] = profilo.Ore6;
                            vm.dipendente.Profilo[6] = profilo.Ore7;
                        }
                    });
                }
            });
        }

        function getHolidays() {
            return vm.holidays = datacontext.festivita_getAll().then(function (data) {
                return vm.holidays = data;
            });
        }

        function getTimeSheet() {
            vm.loading = true;

            if (vm.fAnno < 0)
                vm.fAnno = new Date().getFullYear();
            if (vm.fMese < 1 || vm.fMese > 12)
                vm.fMese = 1;

            var dataFine = new Date(vm.fAnno, vm.fMese, 0);

            vm.date = [];
            vm.giorni = [];
            vm.gSett = [];
            vm.colFestivo = [];
            vm.colSabati = [];
            vm.colDomeniche = [];
            vm.righeC = [];
            vm.righeG = [];
            
            vm.rigaTotOrdinario = [];
            vm.TotaleOrdinario = 0;
            vm.rigaTotStraordinario = [];
            vm.TotaleStraordinario = 0;
            vm.rigaTotViaggio = [];
            vm.TotaleViaggio = 0;
            vm.rigaTotTrasferta = [];
            vm.TotaleTrasferta = 0;
            vm.rigaTotGiustificativi = [];
            vm.TotaleGiustificativi = 0;
            vm.rigaTot = [];
            vm.Totale = 0;
          
            for (var i = 0; i < dataFine.getDate() ; i++) {
                vm.rigaTotOrdinario.push({ "id": i, "value": 0 });
                vm.rigaTotStraordinario.push({ "id": i, "value": 0 });
                vm.rigaTotViaggio.push({ "id": i, "value": 0 });
                vm.rigaTotTrasferta.push({ "id": i, "value": 0 });
                vm.rigaTotGiustificativi.push({ "id": i, "value": 0 });
                vm.rigaTot.push({ "id": i, "value": 0 });

                vm.date[i] = moment().year(vm.fAnno).month(vm.fMese - 1).date(i + 1);
                vm.giorni[i] = String(vm.date[i].format('L')).substring(0, 5);
                vm.gSett[i] = String(vm.date[i].format('dddd')).substring(0, 3);
                if (vm.gSett[i] == 'Sab' || vm.gSett[i] == 'Sat')
                    vm.colSabati[i] = true;
                else
                    vm.colSabati[i] = false;
                if (vm.gSett[i] == 'Dom' || vm.gSett[i] == 'Sun')
                    vm.colDomeniche[i] = true;
                else
                    vm.colDomeniche[i] = false;

                vm.colFestivo[i] = false;               

                var giorno = vm.date[i].date();
                var mese = vm.date[i].month() + 1;
                var anno = vm.date[i].year();
                var check = null;
                check = _.find(vm.holidays, function (o) {
                    return (o.giorno == giorno && o.mese == mese && (o.anno == 0 || o.anno == anno))
                });

                if (check != null) {
                    vm.colFestivo[i] = true;
                    vm.colTitle[i] = check.descrizione;                    
                }
                else {
                    vm.colFestivo[i] = false;
                    vm.colTitle[i] = '';
                }                
            }

            vm.inizio = vm.date[0].format('L');
            vm.fine = vm.date[dataFine.getDate() - 1].format('L');

            datacontext.timeSheet_getMensile(vm.dipendente.Id, vm.fAnno, vm.fMese).then(function (data) {                                
                if (data && data.length > 0) {
                    var ordinario = _.chain(_.filter(data, { 'giustificativo': 0 })).groupBy(function (value) { return [value.commessa, value.item, value.sezione, value.cod_att, value.causale]; }).map(function (v, i) {
                        var iArr = i.split(',');
                        return {
                            commessa: iArr[0],
                            item: iArr[1],
                            sezione: iArr[2],
                            cod_att: iArr[3],
                            causale: iArr[4],
                            ore: v                            
                        }
                    }).value();
                    
                    var giustificativo = _.chain(_.filter(data, { 'giustificativo': 1 })).groupBy('tipoGiustificativo').map(function (v, i) {
                        return {
                            tipoGiustificativo: i,
                            ore: v
                        }
                    }).value();

                    if (ordinario && ordinario.length > 0) {
                        vm.righeC = ordinario;
                        //Segno le ore   
                        vm.righeC.forEach(function (rigaC) {
                            var somma = 0;
                            rigaC.oreC = [];
                            for (var k = 0; k < dataFine.getDate() ; k++) {
                                rigaC.oreC[k] = { 'id': k, 'value': 0 };
                            }                                


                            for (var i = 0; i < rigaC.ore.length; i++) {
                                rigaC.oreC[rigaC.ore[i].giorno - 1].value = rigaC.ore[i].ore_lavoro;
                                somma += rigaC.ore[i].ore_lavoro;                       
                            }
                            
                            rigaC.Totale = somma;   //Somma per riga
                            rigaC.Totale = parseFloat(rigaC.Totale.toFixed(2));

                        });
                    } 

                    if (giustificativo && giustificativo.length > 0) {
                        vm.righeG = giustificativo;
                        //Segno le ore                        
                        vm.righeG.forEach(function (rigaG) {
                            var somma = 0;
                            rigaG.oreG = [];
                            for (var k = 0; k < dataFine.getDate() ; k++)
                                rigaG.oreG[k] = { 'id': k, 'value': 0 };

                            for (var i = 0; i < rigaG.ore.length; i++) {
                                /*if (rigaG.ore[i].trasferta == 0) {*/
                                    rigaG.oreG[rigaG.ore[i].giorno - 1].value = rigaG.ore[i].ore_lavoro;
                                    somma += rigaG.ore[i].ore_lavoro;
                                //}
                            }
                            rigaG.Totale = somma;
                            rigaG.Totale = parseFloat(rigaG.Totale.toFixed(2));
                        });
                    }
                }

                //Righe totali                                
                datacontext.timeSheet_getRiepilogo(vm.dipendente.Id, vm.fAnno, vm.fMese).then(function (data) {  
                    if (data && data.length > 0) {                        
                        data.forEach(function (item) {                            
                            var g = moment(item.Data).date() - 1;
                            
                            vm.rigaTotOrdinario[g].value = item.Ordinario;
                            vm.TotaleOrdinario += item.Ordinario;
                            vm.rigaTotStraordinario[g].value = item.Straordinario;
                            vm.TotaleStraordinario += item.Straordinario;
                            vm.rigaTotViaggio[g].value = item.Viaggio;
                            vm.TotaleViaggio += item.Viaggio;
                            vm.rigaTotTrasferta[g].value = item.Trasferta;
                            vm.TotaleTrasferta += item.Trasferta;
                            vm.rigaTotGiustificativi[g].value = item.Giustificativi;
                            vm.TotaleGiustificativi += item.Giustificativi;
                            vm.rigaTot[g].value = item.Ordinario + item.Straordinario + item.Viaggio + item.Trasferta + item.Giustificativi;
                            vm.Totale += item.Ordinario + item.Straordinario + item.Viaggio + item.Trasferta + item.Giustificativi;
                        });
                    }                    
                });            
                
                vm.loading = false;
            });
        }        

        function next() {
            var x = vm.fMese + 1;
            if (x > 12) {
                vm.fMese = 1;
                vm.fAnno++;
            }
            else
                vm.fMese++;

            getTimeSheet();
        }

        function prev() {
            var x = vm.fMese - 1;
            if (x <= 0) {
                vm.fMese = 12;
                vm.fAnno--;
            }
            else
                vm.fMese--;

            getTimeSheet();
        }

        vm.filterKeydown = function (event, vm) {
            if (event.keyCode == 13) getTimeSheet();
        }

        // Selezione dipendente
        function selezionaDipendente() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/dipendenteSelect.html?version=30',
                controller: 'dipendenteSelect',
                windowClass: 'modal-wide',
                resolve: {}
            });

            modalInstance.result.then(function (returnItem) {
                getDipendente(returnItem.id).then(function () {
                    getTimeSheet();
                });
            });
        }

        function annullaDipendente() {
            getDipendente($rootScope.Id).then(function () {
                getTimeSheet();
            });
        }

        function printTimeSheet(bPDF) {
            if (vm.loading == true)
                return;

            vm.loading = true; 
            datacontext.report_getTimeSheetMensile(bPDF, vm.dipendente.Id, vm.fAnno, vm.fMese).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    document.body.appendChild(a);
                    a.href = data.url;
                    a.click();
                    document.body.removeChild(a);
                    vm.url = data.url;
                }
                else
                    logError($translate.instant('Impossibile scaricare il file'));

                vm.loading = false;
            });
        }
    }
})();